/* ══════════════════════════════════════
   STORE 03 — AUTOMATIC FREE GIFT
   Adds 1 free gift per order when the cart
   holds any other item; removes it when the
   cart is emptied. One per order, not 1:1.
   Config comes from window.__freeGift (see
   snippets/free-gift.liquid).
══════════════════════════════════════ */
(function () {
  const cfg = window.__freeGift;
  if (!cfg || !cfg.variantId) return;

  const GIFT_VARIANT_ID = Number(cfg.variantId);
  const ENABLED = cfg.enabled === true;

  // Line item property used to tag / recognise our gift.
  const GIFT_PROP = { _free_gift: 'yes' };

  const ROUTES = window.routes || {};
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const BASE = ROOT.replace(/\/$/, '');
  const CART_JS = (ROUTES.cart_url || BASE + '/cart') + '.js';
  const ADD_URL = ROUTES.cart_add_url || BASE + '/cart/add';
  const CHANGE_URL = ROUTES.cart_change_url || BASE + '/cart/change';

  // Section IDs to re-render, mapped to how their HTML is injected into the DOM.
  // Mirrors Dawn's cart-drawer.js / cart.js getSectionsToRender().
  const RENDER_TARGETS = {
    'cart-drawer': { host: '#CartDrawer', parse: '#CartDrawer' },
    'cart-icon-bubble': { host: '#cart-icon-bubble', parse: '.shopify-section' },
    'main-cart-items': { host: '#main-cart-items .js-contents', parse: '.js-contents' },
    'main-cart-footer': { host: '#main-cart-footer .js-contents', parse: '.js-contents' },
  };

  let running = false;

  function sectionsOnPage() {
    return Object.keys(RENDER_TARGETS).filter((id) => {
      const host = RENDER_TARGETS[id].host;
      return document.querySelector(host);
    });
  }

  function isGiftLine(item) {
    return Number(item.variant_id) === GIFT_VARIANT_ID;
  }

  function realItemCount(cart) {
    return cart.items.reduce((sum, item) => sum + (isGiftLine(item) ? 0 : item.quantity), 0);
  }

  async function getCart() {
    const res = await fetch(CART_JS, { headers: { Accept: 'application/json' } });
    return res.json();
  }

  async function post(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    return res.json();
  }

  function withSections(body) {
    const ids = sectionsOnPage();
    if (ids.length) {
      body.sections = ids;
      body.sections_url = window.location.pathname;
    }
    return body;
  }

  function getInnerHTML(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function renderSections(sections) {
    if (!sections) return;
    Object.keys(RENDER_TARGETS).forEach((id) => {
      const html = sections[id];
      if (!html) return;
      const target = RENDER_TARGETS[id];
      const host = document.querySelector(target.host);
      if (!host) return;
      const inner = getInnerHTML(html, target.parse);
      if (inner != null) host.innerHTML = inner;
    });
  }

  function setEmptyState(isEmpty) {
    document.querySelectorAll('cart-drawer, cart-drawer-items').forEach((el) => {
      el.classList.toggle('is-empty', isEmpty);
      const innerEmpty = el.querySelector('.drawer__inner');
      if (innerEmpty) innerEmpty.classList.toggle('is-empty', isEmpty);
    });
  }

  async function addGift() {
    return post(
      ADD_URL,
      withSections({ items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: GIFT_PROP }] })
    );
  }

  async function changeGift(gift, quantity) {
    return post(CHANGE_URL, withSections({ id: gift.key, quantity: quantity }));
  }

  // Bring the cart in line with the "one free gift per order" rule.
  async function reconcile() {
    if (running) return;
    running = true;
    try {
      const cart = await getCart();
      const gift = cart.items.find(isGiftLine);
      const realCount = realItemCount(cart);
      let response = null;

      if (ENABLED && realCount > 0) {
        if (!gift) {
          response = await addGift();
          // Let the cart toast know a gift was added on THIS add (fires once
          // per order, since the gift is only added when real items go 0 -> 1+).
          if (response && !response.status) {
            document.dispatchEvent(
              new CustomEvent('free-gift:added', {
                detail: { title: cfg.title || 'Free gift' },
              })
            );
          }
        } else if (gift.quantity !== 1) {
          // Never let the gift exceed one per order.
          response = await changeGift(gift, 1);
        }
      } else if (gift) {
        // Cart emptied of real items, or feature disabled — pull the gift.
        response = await changeGift(gift, 0);
      }

      if (response && response.sections) {
        renderSections(response.sections);
        if (typeof response.item_count === 'number') setEmptyState(response.item_count === 0);
      }
    } catch (e) {
      console.warn('[free-gift] reconcile failed:', e);
    } finally {
      running = false;
    }
  }

  function waitForPubSub(cb, tries) {
    tries = tries || 0;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      cb();
    } else if (tries < 50) {
      setTimeout(() => waitForPubSub(cb, tries + 1), 100);
    }
  }

  function init() {
    // Fix stale carts on every load (also cleans up the gift when disabled).
    reconcile();

    if (!ENABLED) return;

    // React to every cart mutation the theme performs (add / change / remove).
    waitForPubSub(() => {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        // reconcile is idempotent and self-guarded against re-entry.
        reconcile();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
